import { render } from "./Tixian.vue?vue&type=template&id=2d0914c8&scoped=true"
import script from "./Tixian.vue?vue&type=script&lang=js"
export * from "./Tixian.vue?vue&type=script&lang=js"

import "./Tixian.vue?vue&type=style&index=0&id=2d0914c8&lang=scss&scoped=true"

import exportComponent from "D:\\svn_gongzuo\\_____base\\GoPay\\v3_gopay\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0914c8"]])

export default __exports__